export const ERROR_IDS = {
    TWO_FA_NOT_PROVIDED: 'google.2fa.not.provided',
};
